$(document).on('click', '#next_link', function() {
  $('#div_next_link').html('<img src="/loading.gif" class="img-fluid" alt="Loading..." title="Loading..." />');
});
